/* ==========================================================================
   TB-CUSTOM — Tahoe Bay customizations
   --------------------------------------------------------------------------
   Store-specific JS lives here rather than in FoxEcom's scripts, so Zest
   updates never have to merge around it. Add new behaviour here by default.
   ========================================================================== */

(function () {
  'use strict';

  /* ------------------------------------------------------------------------
     Single-select colour filter
     Paired with the .f-facets__list--color block in snippets/facets.liquid
     ------------------------------------------------------------------------ */

  /* The colour facet ships as checkboxes, so picking a second colour widens the
     result set instead of replacing the first. Uncheck the group's other values
     before the theme reads the form, which turns it into a pick-one filter
     without touching FoxEcom's facets.js.

     facets.liquid puts .f-facets__list--color on a filter's value list when the
     filter label matches settings.color_swatches_trigger (facets.liquid:154) or
     the filter uses Shopify's swatch presentation. Colour is the only such
     filter on this store; if a second swatch filter is ever added and should
     stay multi-select, narrow this selector to that list.

     Pruning is limited to inputs sharing the changed input's name — one filter
     group's param — so every other group keeps its selections. */

  var COLOUR_LIST_SELECTOR = '.f-facets__list--color';

  /* Capture phase on document, deliberately: FacetFiltersForm listens for the
     same input event while it bubbles back up to <facet-filters-form> and
     builds the request straight from FormData (facets.js:9, :175). Capturing
     runs first, so the request already carries a single colour — no second
     render, no flash of the wrong result set. */
  document.addEventListener(
    'input',
    function (event) {
      var input = event.target;

      if (!(input instanceof HTMLInputElement)) return;

      /* Only a newly selected value displaces anything. Clearing one is the
         theme's normal toggle-off and must keep working. */
      if (!input.checked) return;
      if (!input.closest(COLOUR_LIST_SELECTOR)) return;

      /* input.form covers the drawer and sidebar alike; the list is a fallback
         for markup that ever renders outside a form. */
      var scope = input.form || input.closest(COLOUR_LIST_SELECTOR);

      /* Compared in JS rather than via an attribute selector because filter
         params (filter.v.option.color) are not safe to interpolate verbatim. */
      scope.querySelectorAll('input:checked').forEach(function (other) {
        if (other !== input && other.name === input.name) {
          other.checked = false;
        }
      });
    },
    true
  );
})();
